import { useState, useEffect } from 'react';
import qs from 'query-string';

const useQueryAppender = (url, query) => {
  const [urlState, setUrlState] = useState(url);

  useEffect(() => {
    const queryToAppend = qs.parse(query);
    const { url: cleanUrl, query: queryFromUrl } = qs.parseUrl(url);
    const newUrl = qs.stringifyUrl({
      url: cleanUrl,
      query: { ...queryToAppend, ...queryFromUrl },
    });
    setUrlState(newUrl);
  }, [query]);

  return urlState;
};

export default useQueryAppender;
